'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const cards = [
	{
		title: 'Бесперебойная работа',
		description: 'Создаем уникальные цифровые решения или адаптируем готовые под потребности вашего бизнеса. Разрабатываем сайты и приложения, интегрируем системы и модули',
		items: [
			'Мониторинг 24/7: автоматические системы проверяют доступность сайта, работу баз данных и критических узлов.',
			'Безопасность: защита от DDoS-атак, ежедневное резервное копирование в облако, контроль сроков действия SSL-сертификатов и доменов.',
			'Лечение и профилактика: оперативное устранение вирусов, закрытие уязвимостей, обновление серверного ПО.'
		],
		image: '/images/services/custom-development-1.svg',
	},
	{
		title: 'Развитие и модернизация',
		description: 'Создаем уникальные цифровые решения или адаптируем готовые под потребности вашего бизнеса. Разрабатываем сайты и приложения, интегрируем системы и модули',
		items: [
			'Обновление ядра: регулярные апдейты CMS и версий PHP для соответствия стандартам безопасности.',
			'Функциональные доработки: создание разделов, личных кабинетов, интеграция с 1С, CRM и платёжными шлюзами.',
			'UX/UI улучшения: адаптация интерфейсов, редизайн элементов для повышения конверсии.'
		],
		image: '/images/services/custom-development-2.svg',
	},
	{
		title: 'Оптимизация',
		description: 'Создаем уникальные цифровые решения или адаптируем готовые под потребности вашего бизнеса. Разрабатываем сайты и приложения, интегрируем системы и модули',
		items: [
			'Ускорение сайта: работа с метриками сайта. Оптимизация кода, сжатие изображений, настройка кэширования.',
			'Подготовка к нагрузкам: масштабирование архитектуры перед маркетинговыми акциями и сезонными пиками.'
		],
		image: '/images/services/custom-development-3.svg',
	}
]

const ServiceComposition: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Состав услуги
					</Typography>
					<Typography variant='h2' className={styles.title}>
						Что входит в тех. сопровождение?
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
					Техническое сопровождение — это не просто исправление ошибок. Это стратегия цифровой устойчивости. Мы предлагаем комплексный подход, разделённый на три ключевых направления:
					</Typography>
				</div>
			</AnimatedSection>

			<div className={styles.cards}>
				{cards.map((card, idx) => (
					<AnimatedSection key={idx} animation="slideUp">
						<div className={styles.card}>
							<div className={styles.cardImage}>
								<Image
									src={card.image}
									alt={card.title}
									width={310}
									height={120}
									className={styles.image}
								/>
							</div>
							<div className={styles.cardContent}>
								<Typography variant='h3' className={styles.cardTitle}>
									{card.title}
								</Typography>
								{/* Список для десктопа/планшета */}
								<ul className={styles.cardList}>
									{card.items.map((item, itemIdx) => (
										<li key={itemIdx} className={styles.cardListItem}>
											{item}
										</li>
									))}
								</ul>
								{/* Description для мобилки */}
								<Typography variant='p1' color='description' className={styles.cardDescriptionMobile}>
									{card.description}
								</Typography>
							</div>
						</div>
					</AnimatedSection>
				))}
			</div>
		</section>
	)
}

ServiceComposition.displayName = 'ServiceComposition'

export default ServiceComposition

